import React from "react";
import { Route, Routes } from 'react-router-dom'
import Events from "../pages/operator/events/Events";
import NewEvent from "../pages/operator/new-event/NewEvent";



const OperatorRoute = (props) => {
    return (
        <Routes>
            <Route
                exact
                path="/admin/add-event"
                element={<NewEvent token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
           
            <Route
                exact
                path="/admin/events"
                element={<Events token={props.token} bodyNotify={props.bodyNotify} validateToken={props.validateToken}/>}
            />
        </Routes>
    )
}


export default OperatorRoute